import React from "react";
import {
  motion,
  Variants,
  useInView,
  useAnimation,
  transform,
} from "framer-motion";

export const RevealVariants = {
  shown: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.1,
    },
  },
  shownFast: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 0.1,
    },
  },
  hiddenLeft: {
    opacity: 0,
    x: 0,
    transition: {
      duration: 0.1,
    },
  },
  hiddenFade: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
    },
  },
  hover: {
    scale: 1.1,

    transition: {
      duration: 0.1,
      ease: "linear",
    },
  },
  showOnce: false,
};
